import { PREFERENCE_MANAGEMENT } from "constants/types";
import {
  getPreferencesService,
  logPreferenceEventService,
  submitPreferencesService,
} from "modules/Services/PreferenceManagementServices";
import store from "store";

export const getPreferences = (unsubid: any) => {
  store.dispatch({
    type: PREFERENCE_MANAGEMENT.LOAD_PREFERENCES,
    payload: {
      id: unsubid,
    },
  });
  return getPreferencesService(unsubid).then((res: any) => {
    const data = res.data;
    if (data.status !== "True") {
      store.dispatch({
        type: PREFERENCE_MANAGEMENT.LOAD_FAIL_PREFERENCES,
      });
    } else {
      let preferencesState: any = { ...data };
      delete preferencesState.success;
      delete preferencesState.status;

      store.dispatch({
        type: PREFERENCE_MANAGEMENT.LOAD_SUCCESS_PREFERENCES,
        payload: preferencesState,
      });
    }
  });
};
export const submitPreferences = () => {
  return submitPreferencesService();
};

export const changeHandlerAction = (key: string, value: string, id?: number) => {
  store.dispatch({
    type: key === "unsub_all" ? PREFERENCE_MANAGEMENT.CHANGE_UNSUBALL : PREFERENCE_MANAGEMENT.CHANGE_ACTION,
    payload: {
      key,
      value,
      id,
    },
  });
  const preferenceManagement = store.getState().preferenceManagement;
  const newsLetterIds =
    preferenceManagement?.news_letters?.map((newsLetter: any) => newsLetter.id).join(",") ?? "";
  const alertsNames = preferenceManagement?.alerts?.map((alert: any) => alert.name).join(",") ?? "";

  logPreferenceEventService({
    unsub_uuid: preferenceManagement.id,
    status: value,
    timestamp: `${Date.now()}`,
    key: key === "news_letters" ? "digests" : key === "unsub_all" ? "all" : key,
    ...(key === "news_letters" ? { news_letters_subscribed: id ? `${id}` : newsLetterIds } : {}),
    ...(key === "alerts" ? { alerts_subscribed: id ? `${id}` : alertsNames } : {}),
  });
};
